import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import api from './dock';
import plugins from './components/index';

import MobileDetect from './assets/js/mobile-detect.min.js';

// import 'vant/lib/index.css';
Vue.config.productionTip = false; // 存放一些js处理
Vue.prototype.$api = api;
Vue.use(plugins);


// 判断数组中是否包含某字符串
Array.prototype.contains = function (needle) {
  for (i in this) {
    if (this[i].indexOf(needle) > 0) {
      return i;
    }
  }
  return -1;
};
const device_type = navigator.userAgent; // 获取userAgent信息
const md = new MobileDetect(device_type); // 实例化mobile-detect
let os = md.os(); // 获取系统
let model = '';
if (os == 'iOS') { // ios系统的处理
  os = md.os() + md.version('iPhone');
  model = md.mobile();
} else if (os == 'AndroidOS') { // Android系统的处理
  os = md.os() + md.version('Android');
}
store.state.model = os;


var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  const hm = document.createElement('script');
  hm.src = 'https://hm.baidu.com/hm.js?3d92558de28b2177613d3517af615621';
  const s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
}());

function getUrlParam(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`); // 构造一个含有目标参数的正则表达式对象
  const r = window.location.search.substr(1).match(reg); // 匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; // 返回参数值
}


router.beforeEach((to, from, next) => {
  // ?alias=oxRsxa

  const appid = 'wxc4c51af20f61d4b6';
  const url = 'https://huace.9071design.com/wap/';


  if (window.location.href.indexOf('?from=') != -1) {
    return window.location = url + window.location.href.substring(window.location.href.indexOf('#'), window.location
      .href.length);
  }

  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', `/#${to.fullPath}`]);
    }
  }

  const paramData = api.parseUrl();
  try {
    if (paramData.alias && (store.state.loginInfo.album_alias == '' || store.state.loginInfo.album_alias
        == undefined)) {
      api.setItem({
        name: 'album_alias',
        value: paramData.alias,

      });
      store.state.loginInfo.album_alias = paramData.alias;
    }
  } catch (e) {
    // TODO handle the exception
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }

  if (localStorage.openid) {
    api.commit('openid', localStorage.openid);
  }

  if ((localStorage.openid == 'undefined' || !localStorage.openid && store.state.openid == null) && (to.path
      == '/contactCatalog/progeny/signIn' || to.path == '/adminupgrade')) {
    // 重新授权登陆
    if (getUrlParam('code') == null) {
      localStorage.href = window.location.href.substring(window.location.href.indexOf('#') + 1, window.location.href
        .length);
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid
      }&response_type=code&scope=snsapi_userinfo&redirect_uri=${url}&state=1#wechat_redirect`;
    }
  } else {
    next();
  }
});


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
